import React from "react";
import { useWebSocket } from "./websocket";
import ImportantToast from "../common/important-toast";

const WebSocketConnectionToast = () => {
  const { ws, wsReady, reconnect } = useWebSocket();

  // List of paths where we don't want to show the toast
  const excludedPaths = [
    "/user-login",
    "/user-login-callback",
    "/user-logout",
    "/developer-logout",
    "/developer-login",
    "/developer-login-callback",
    "/init-scope",
    "/desktop-login",
    "/desktop-auth-wait",
    "/desktop-auth-done",
  ];

  // Check if WebSocket is open
  const checkWebSocketOpen = () => {
    return ws && ws.readyState === WebSocket.OPEN;
  };

  return (
    <ImportantToast
      isOpen={wsReady}
      onAction={reconnect}
      message="Connection lost"
      actionButtonText="Reconnect"
      excludedPaths={excludedPaths}
      checkCondition={checkWebSocketOpen}
      delay={2000}
    />
  );
};

export default WebSocketConnectionToast;
